import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  note?: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  note,
  id,
  className = ''
}: CTAButtonProps) {
  return <div className={`w-full ${className}`} data-id="element-25" data-mp="2fzv031ajki33">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-2xl bg-gold px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide text-ink shadow-[0_10px_30px_-10px_rgba(200,162,76,0.7)] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-gold-light active:scale-[0.98] sm:text-lg" data-id="element-26" data-mp="2fyscp3cfgxrx">
        <span data-id="element-27" data-mp="2yqursa9f8602">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="3cpual1a95qob" />
      </a>
      {note ? <p className="mt-3 text-center text-[12px] font-medium leading-relaxed text-cream/60 sm:text-[13px]" data-id="element-29" data-mp="198wkn9dori4l">
          {note}
        </p> : null}
    </div>;
}